import React from 'react';

const Introduction = () => {
  return (
    <section>
      <h2 className="section-title">What Are Values?</h2>
      <div className="section-card">
        <p className="intro-text">
          Values are deeply held beliefs about what is important, desirable, and worth striving for in life. 
          As a psychological concept, values serve as guiding principles that influence our attitudes, 
          decisions, and behaviors. They represent our fundamental convictions about what matters most to us 
          and what kind of person we aspire to be.
        </p>
      </div>
    </section>
  );
};

export default Introduction;